import Api from './api';

class Makes {
    static async get() {
        return await Api.get('make-service/get');
    }
    static async post(name) {
        return await Api.post('make-service/add', { name });
    }
    static async getSynonyms(id) {
        return await Api.get('make-service/get-synonyms', { idMake: id });
    }
    static async addSynonym(name, idMake) {
        return await Api.post('make-service/add-synonym', { name, idMake: String(idMake) });
    }
    static async getPopular(idRegion) {
        return await Api.get('make-service/get', { idRegion, popular: 1 });
    }
    static async getUnpopular(idRegion) {
        return await Api.get('make-service/get', { idRegion, popular: 0 });
    }
    static async setPopular(idRegion, idMake) {
        return await Api.post('make-service/set-popularity-in-region', { idRegion: String(idRegion), idMake: String(idMake), popularity: "1" });
    }
    static async setUnpopular(idRegion, idMake) {
        return await Api.post('make-service/set-popularity-in-region', { idRegion: String(idRegion), idMake: String(idMake), popularity: "0" });
    }
    static async setAllPopular(idRegion) {
        return await Api.post('make-service/set-popularity-in-region', { idRegion: String(idRegion), popularity: "1" });
    }
    static async setAllUnpopular(idRegion) {
        return await Api.post('make-service/set-popularity-in-region', { idRegion: String(idRegion), popularity: "0" });
    }
    static async update({ id, oldName, newName }) {
        return await Api.post('make-service/rename', { idMake: String(id), oldName, newName });
    }
    static async updateSynonym({ idMake, oldName, newName }) {
        return await Api.post('make-service/rename-synonym', { idMake: String(idMake), oldName, newName });
    }
    static async delete(id) {
        return await Api.post('make-service/delete', { id: String(id) });
    }
    static async deleteSynonym(name, idMake) {
        return await Api.post('make-service/delete-synonym', { name, idMake: String(idMake) });
    }
}

export default Makes;